var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashiconsEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.80511 6H25.6801C27.5551 6 28.5001 6.885 28.5001 8.685V21.315C28.5001 23.1 27.5551 24 25.6801 24H5.80511C3.93011 24 2.98511 23.1 2.98511 21.315V8.685C2.98511 6.885 3.93011 6 5.80511 6ZM15.7351 18.9L25.8451 10.605C26.2051 10.305 26.4901 9.615 26.0401 9C25.6051 8.385 24.8101 8.37 24.2851 8.745L15.7351 14.535L7.20011 8.745C6.67511 8.37 5.88011 8.385 5.44511 9C4.99511 9.615 5.28011 10.305 5.64011 10.605L15.7351 18.9Z",
    fill: "#000000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashiconsEmail);
export default __webpack_public_path__ + "static/media/dashicons_email.9fb1f08ff88fc20a63f11318f5e08a8c.svg";
export { ForwardRef as ReactComponent };